<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 查看
    <view-dialog
      :data-id="id"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />
    -->
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 查看
// import ViewDialog from './components/viewDialog'
// 数据请求
import { loadStoreInfoCollectPlanListDataApi, loadStoreInfoCollectPlanExportDataApi } from '@/api/storeInfoCollectPlan'
export default {
  name: 'StoreInfoCollectPlan',
  components: {
    CustomTable,
    TableOperation
    // ViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'store_info_collect_plan_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          // {
          //   permissionSigns: ['store_info_view'],
          //   prop: 'view',
          //   label: '查看',
          //   method: 'view'
          // },
          {
            permissionSigns: ['store_info_collect_plan_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: 'id', // 排序字段
            order: 'desc' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            storeName: '',
            certificateNo: ''
          }
        }
      },
      id: null, // 选中的单据ID
      cityId: null,
      eventType: '',
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      dialogViewTitle: '',
      dialogViewVisible: false,
      dialogCollectionPlanVisible: false // 制定采集品规

    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '所属省区', filterColumn: 's.province_name', width: 120 },
      { prop: 'cityName', label: '所属城市', filterColumn: 's.city_name', width: 120 },
      { prop: 'countyName', label: '所属区县', filterColumn: 's.county_name', width: 120 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 's.certificate_no', width: 120 },
      { prop: 'storeName', label: '店名(专卖证)', filterColumn: 's.store_name', width: 150 },
      { prop: 'address', label: '地址(专卖证)', filterColumn: 's.address', width: 150 },
      { prop: 'realStoreName', label: '实际店名', filterColumn: 's.real_store_name', width: 150 },
      { prop: 'realAddress', label: '实际地址', filterColumn: 's.real_address', width: 150 },
      { prop: 'ownerName', label: '店主姓名', filterColumn: 's.owner_name', width: 120 },
      { prop: 'phone', label: '联系电话', filterColumn: 's.phone', width: 120 },
      { prop: 'sortStr', label: '采集类型', filterColumn: '(case bill.sort when 1 then \'新品动销调查\' when 2 then \'零售监测\' else \'\' end)', width: 120 },
      { prop: 'collectUserName', label: '采集人', filterColumn: 'bill.collect_user_name', width: 120 },
      { prop: 'planCollectDateStr', label: '采集日期', filterColumn: 'DATE_FORMAT(bill.plan_collect_date,\'%Y-%m-%d\')', width: 120 },
      { prop: 'planCollectDayStr', label: '采集周几', filterColumn: '(case bill.plan_collect_day when 1 then \'周一\' when 2 then \'周二\' when 3 then \'周三\' when 4 then \'周四\' when 5 then \'周五\' when 6 then \'周六\' when 7 then \'周日\' else \'\' end)', width: 120 },
      { prop: 'isCollectedStr', label: '是否已采集', filterColumn: '(case bill.is_collected when 1 then \'是\' else \'否\' end)', width: 120 },
      { prop: 'isIgnoreStr', label: '是否忽略', filterColumn: '(case bill.is_ignore when 1 then \'是\' else \'否\' end)', width: 120 },
      { prop: 'ignoreOperatorName', label: '忽略人', filterColumn: 'bill.ignore_operator_name', width: 150 },
      { prop: 'ignoreOperationTimeStr', label: '忽略时间', filterColumn: 'IF(bill.ignore_operation_time is null,\'\',DATE_FORMAT(bill.ignore_operation_time,\'%Y-%m-%d %H:%i:%s\'))', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadStoreInfoCollectPlanListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      // this.dialogViewVisible = !this.dialogViewVisible
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadStoreInfoCollectPlanExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
